export const API_ERRORS = {
  NOT_AUTHORIZED: 401,
  FIELDS_VALIDATION: 1001
};

export const API_ERROR_CODES = {
  default: 9999,
  e9999: 'DEFAULT_ERROR'
};

export const BASE_ERROR = {
  code: 9999,
  description: API_ERROR_CODES.e9999,
  message: 'Malformed error from API'
};

export const CANCEL_REQUEST_ERROR = 'CANCEL_ERROR';
